export const initEventItemExpandToggle = () => {
	$(document).on("click", ".i-event-item-expand-btn", e => {
		const btn = $(e.currentTarget);
		const toggleText = btn.attr("data-toggle-text");
		const currentText = btn.find(".i-event-item-expand-btn__text").text();
		const wrapper = btn.parents(".i-event-item");

		btn.find(".i-event-item-expand-btn__text").text(toggleText);
		btn.attr("data-toggle-text", currentText);

		wrapper.find(".i-event-item-expand").slideToggle();
	});
};
